export const BUSINESS_ROLES = {
  superadmin: {
    label: "SuperAdmin",
    description:
      "Full access to everything, including Team Settings, Billing, role assignment, setup, accounting, payroll, CRM and all reports.",
  },
  manager: {
    label: "Manager",
    description:
      "Can access almost everything except Team Settings and Billing.",
  },
  accountant: {
    label: "Accountant",
    description:
      "Can access Manager-level finance features except Setup, Team Settings and Billing.",
  },
  hr: {
    label: "Human Resource",
    description: "Can access Payroll Management only.",
  },
  marketing: {
    label: "Marketing",
    description: "Can access CRM only.",
  },
  operations: {
    label: "Operations",
    description:
      "Can access operations pages including customers, vendors, inventory, bookings, budgets, invoices, receipts, estimates, AR/AP and basic reports. Cannot create journals.",
  },
  reviewer: {
    label: "Reviewer",
    description:
      "Read-only style access to dashboard, inventory dashboard and reports.",
  },
};

const ROLE_DEFAULT_PATH = {
  superadmin: "/dashboard",
  manager: "/dashboard",
  accountant: "/dashboard",
  hr: "/payroll/dashboard",
  marketing: "/crm",
  operations: "/dashboard",
  reviewer: "/dashboard",
};

const OPERATIONS_ALLOWED = [
  "/dashboard",
  "/customers",
  "/sales-quick",
  "/purchases-quick",
  "/bookings",
  "/scheduling",
  "/budgets",
  "/vendors",
  "/inventory",
  "/inventory/items",
  "/inventory/movements",
  "/inventory/stock-on-hand",
  "/fixed-assets",
  "/subledger/ar",
  "/subledger/ap",
  "/estimate",
  "/invoice",
  "/receipt",
  "/total_estimate",
  "/total_invoice",
  "/totalReceipts",
  "/income",
  "/sales-history",
  "/purchase-history",
  "/account-ledger",
  "/inventory-valuation",
];

const REVIEWER_ALLOWED = [
  "/dashboard",
  "/inventory",
  "/report",
  "/income",
  "/sofp",
  "/cashFlows",
  "/managementReport",
  "/inventory-valuation",
  "/stock-ageing",
];

function pathMatches(pathname, allowedPath) {
  return pathname === allowedPath || pathname.startsWith(`${allowedPath}/`);
}

export function getDefaultPathForRole(role) {
  return ROLE_DEFAULT_PATH[role] || "/dashboard";
}

export function canAccessBusinessPath(role, pathname) {
  if (!role) return false;

  if (role === "superadmin") return true;

  if (role === "manager") {
    return !["/team-settings", "/billings", "/billing/callback"].some((p) =>
      pathMatches(pathname, p)
    );
  }

  if (role === "accountant") {
    return ![
      "/team-settings",
      "/billings",
      "/billing/callback",
      "/settings",
    ].some((p) => pathMatches(pathname, p));
  }

  if (role === "hr") return pathMatches(pathname, "/payroll");

  if (role === "marketing") return pathMatches(pathname, "/crm");

  if (role === "operations") {
    if (
      pathMatches(pathname, "/journal") ||
      pathMatches(pathname, "/total_journals")
    ) {
      return false;
    }
    return OPERATIONS_ALLOWED.some((p) => pathMatches(pathname, p));
  }

  if (role === "reviewer") {
    return REVIEWER_ALLOWED.some((p) => pathMatches(pathname, p));
  }

  return false;
}
